import { stats } from '@fiverr-private/obs';
import { UploadErrorTypes } from '../../errors/UploadErrorTypes';
import RemoteActionError from '../../errors/RemoteActionError';
import RenamingStrategyHandler from './RenamingStrategy/RenamingStrategyHandler';

export default class UploadHandler {
    constructor(objectName, attachmentName, policyData, fileType, retryAttempts, file, onProgress, shouldRenamed) {
        this.objectName = objectName;
        this.attachmentName = attachmentName;
        this.policyData = policyData;
        this.fileType = fileType;
        this.retryAttempts = retryAttempts;
        this.file = file;
        this.onProgress = onProgress;
        this.shouldRenamed = shouldRenamed;
    }

    abort() {
        this.uploadXhrRequest && this.uploadXhrRequest.abort();
    }

    prepareDataForUpload() {
        const s3Policy = this.policyData.policy.s3_policy;
        const fileType = this.fileType;
        const clientUniqId = Math.floor(Math.random() * 26) + Date.now(),
            clientGuid = s3Policy.guid + s3Policy.client_uniq_id_prefix + clientUniqId,
            key = s3Policy.key.replace(s3Policy.guid, clientGuid),
            formData = new FormData(),
            renamingStrategyHandler = new RenamingStrategyHandler(this.file.name, key, this.shouldRenamed);

        formData.append('acl', s3Policy.acl);
        formData.append('AWSAccessKeyId', s3Policy.AWSAccessKeyId);
        formData.append('success_action_status', s3Policy.success_action_status);
        formData.append('key', renamingStrategyHandler.handle());
        formData.append('policy', s3Policy.policy);
        formData.append('signature', s3Policy.signature);
        formData.append('content-type', fileType);
        formData.append('file', this.file);

        return { formData, s3Policy };
    }

    uploadToS3(s3UploadData) {
        return new Promise((resolve, reject) => {
            const retryableUpload = (retryAttempts) => {
                this.uploadXhrRequest = new XMLHttpRequest();

                this.uploadXhrRequest.upload.onprogress = (progressEvent) => {
                    const percentage = (progressEvent.loaded * 100) / progressEvent.total;
                    this.onProgress({
                        progressEvent,
                        percentage
                    });
                };

                this.uploadXhrRequest.onload = () => {
                    if (this.uploadXhrRequest.status >= 200 && this.uploadXhrRequest.status < 300) {
                        resolve(this.uploadXhrRequest.response);
                    } else {
                        retryAttempts && retryableUpload(retryAttempts - 1);
                        !retryAttempts && reject(new RemoteActionError(this.uploadXhrRequest.status, this.uploadXhrRequest.statusText, UploadErrorTypes.UPLOAD_FILE));
                    }
                };

                this.uploadXhrRequest.onerror = () => {
                    retryAttempts && retryableUpload(retryAttempts - 1);
                    !retryAttempts && reject(new RemoteActionError(this.uploadXhrRequest.status, this.uploadXhrRequest.statusText, UploadErrorTypes.UPLOAD_FILE));
                };

                this.uploadXhrRequest.open('POST', s3UploadData.s3Policy.action_url);

                this.uploadXhrRequest.send(s3UploadData.formData);
            };
            retryableUpload(this.retryAttempts);
        });
    }

    parseS3UploadedData(s3UploadedData) {
        const frag = document.createRange().createContextualFragment(s3UploadedData),
            key = frag.querySelector('Key').firstChild.nodeValue,
            bucketName = frag.querySelector('Bucket').firstChild.nodeValue,
            etag = frag.querySelector('Etag').firstChild.nodeValue.split('"').join('');

        return { key, bucketName, etag };
    }

    async handleUploadLogic() {
        const s3UploadData = this.prepareDataForUpload();
        const startTime = Date.now();
        const s3UploadedData = await this.uploadToS3(s3UploadData);

        stats.time(
            `filerr_uploader.${this.objectName}.${this.attachmentName}`,
            's3_direct_upload',
            Date.now() - startTime
        );

        return this.parseS3UploadedData(s3UploadedData);
    }
}
